import { Link } from 'react-router-dom';
import type { Category } from '@/mocks/types';

interface CategorySectionProps {
  categories: Category[];
}

export default function CategorySection({ categories }: CategorySectionProps) {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            分类浏览
          </h2>
          <p className="mt-3 text-sm text-foreground-500">探索不同类型的韩漫作品，找到你的最爱</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative aspect-square rounded-lg overflow-hidden bg-background-200 cursor-pointer"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-primary-500/10 to-accent-500/10 group-hover:from-primary-500/20 group-hover:to-accent-500/20 transition-all duration-300"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center p-4 text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-background-50/80 flex items-center justify-center mb-3">
                  <i className={`ri-${getCategoryIcon(cat.slug)} text-2xl text-primary-500`}></i>
                </div>
                <h3 className="text-base md:text-lg font-semibold text-foreground-950 whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">
                  收录 {cat.comicCount.toLocaleString()} 部作品
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function getCategoryIcon(slug: string): string {
  const iconMap: Record<string, string> = {
    romance: 'heart-line',
    fantasy: 'magic-line',
    action: 'fire-line',
    thriller: 'search-eye-line',
    comedy: 'emotion-happy-line',
    drama: 'theater-line',
    bl: 'men-line',
    gl: 'women-line',
  };
  return iconMap[slug] || 'book-line';
}